import { render, staticRenderFns } from "./TotalCount.vue?vue&type=template&id=065b4220&scoped=true"
import script from "./TotalCount.vue?vue&type=script&lang=js"
export * from "./TotalCount.vue?vue&type=script&lang=js"
import style0 from "./TotalCount.vue?vue&type=style&index=0&id=065b4220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065b4220",
  null
  
)

export default component.exports